module.exports = __webpack_public_path__ + "static/img/banner6.ac448b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/banner6.jpg
// module id = qOuy
// module chunks = 0